const automatedMessageTypes = {
    REGISTRATION_CONFIRMATION: "REGISTRATION_CONFIRMATION",
    CHECKIN_GREETING: "CHECKIN_GREETING",
    EXHIBITOR_CONTACTS: "EXHIBITOR_CONTACTS",
    EVENT_SUMMARY: "EVENT_SUMMARY",
};

export default automatedMessageTypes;
